import { GlobalDataContext } from '@/contexts/GlobalDataContext';
import { GlobalUserDataContext } from '@/contexts/GlobalUserDataContext';
import { ScreenContext } from '@/contexts/ScreenContext';
import { GameType } from '@/models/games/enums/GameType';
import { HostProps } from '@/utils/commonFunc';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { tableBetSliceActions } from '../betTable/slice';

type VideoFrame = {
    x: number;
    y: number;
    width: number;
    height: number;
};
export const useMultiBetLayout = () => {
    const [dragEnabled, setDragEnabled] = useState<boolean>();
    const [videoId, setVideoId] = useState<number>(-1);
    const [videoViewBox, setVideoVideoBox] = useState<VideoFrame>();
    const [isMBEnlarge, setIsMBEnlarge] = useState<boolean>(false);
    const { videoMBOff, multiBetHostID } = useContext(GlobalDataContext);
    const { isLandscape, isMobile } = useContext(ScreenContext);
    const [emptyMessage, setEmptyMessage] = useState<string>();
    useEffect(() => {
        if (!videoMBOff && multiBetHostID > 0) {
            setVideoId(multiBetHostID);
        }
    }, [videoMBOff, multiBetHostID]);
    const hostProps: HostProps = useMemo(
        () => ({
            hostId: videoId,
            gameType: GameType.MultiBet,
        }),
        [videoId]
    );
    useEffect(() => {
        if (isLandscape) {
            if (!isMobile) {
                setDragEnabled(false);
            } else {
                if (videoMBOff) {
                    //setVideoPosition({ x: -10000, y: 0 });
                } else {
                    setDragEnabled(!isMBEnlarge);
                    // if (isMBEnlarge) {
                    //     document.documentElement.style.setProperty(
                    //         '--multibet-video-height',
                    //         '70'
                    //     );
                    // } else {
                    //     document.documentElement.style.setProperty(
                    //         '--multibet-video-height',
                    //         '25'
                    //     );
                    // }
                }
            }
        } else {
            // if (videoMBOff) {
            //     // setVideoPosition({ x: -10000, y: 0 });
            //     document.documentElement.style.setProperty(
            //         '--multibet-video-height',
            //         '0'
            //     );
            // } else {
            //     document.documentElement.style.setProperty(
            //         '--multibet-video-height',
            //         '34'
            //     );
            //     // setVideoPosition({ x: portraitX, y: 0 });
            // }
            setDragEnabled(false);
        }
    }, [isLandscape, isMBEnlarge, videoMBOff]);
    return {
        videoId,
        hostProps,
        videoViewBox,
        setVideoVideoBox,
        dragEnabled,
        isMBEnlarge,
        setIsMBEnlarge,
        emptyMessage,
        setEmptyMessage,
    };
};
export type MultiBetLayoutState = ReturnType<typeof useMultiBetLayout>;
// type TablePrevBet = {
//     hostid:number,
//     bets:Array<Number>
// }

interface prevBetsMap {
    [key: number]: Array<number>;
}
export const useMultiBetLiveData = () => {
    const [haveNonConfirmedBetTables, sethaveNonConfirmedBetTables] = useState<
        Array<number>
    >([]);
    const tablesPrevBets = useRef<prevBetsMap>({});
    const { isAutoConfirm } = useContext(GlobalUserDataContext);
    const dispatch = useDispatch();
    useEffect(() => {
        return () => {
            if (
                isAutoConfirm === false &&
                haveNonConfirmedBetTables &&
                haveNonConfirmedBetTables.length > 0
            ) {
                //only non-ABC clear pending on init
                for (let i = 0; i < haveNonConfirmedBetTables.length; i++) {
                    dispatch(
                        tableBetSliceActions.clearPendingBets({
                            hostId: haveNonConfirmedBetTables[i],
                            gameId: 0,
                            startGame: false,
                        })
                    );
                }
                sethaveNonConfirmedBetTables([]);
            }
        };
    }, [isAutoConfirm]);
    const setPendingBetState = (hostId: number, value: boolean) => {
        let havePending = haveNonConfirmedBetTables.concat();
        if (value) {
            if (havePending.indexOf(hostId) < 0) {
                havePending.push(hostId);
                sethaveNonConfirmedBetTables([...havePending]);
            }
        } else {
            if (havePending.indexOf(hostId) >= 0) {
                havePending.splice(havePending.indexOf(hostId), 1);
                sethaveNonConfirmedBetTables([...havePending]);
            }
        }
    };
    const setMultibetPrevBets = (hostId: number, value: Array<number>) => {
        tablesPrevBets.current[hostId] = value;
    };
    const getMultibetPrevBets = (hostId: number): Array<number> => {
        return tablesPrevBets.current[hostId];
    };

    return {
        haveNonConfirmedBetTables,
        setPendingBetState,
        setMultibetPrevBets,
        getMultibetPrevBets,
    };
};
export type MultiBetLiveState = ReturnType<typeof useMultiBetLiveData>;
